import React, { useState } from 'react';
import styled from '@emotion/styled';
import { navigate } from 'gatsby';

const SearchWrapper = styled.form`
  width: 100%;
  max-width: 570px;
  margin-bottom: 30px;
  display: flex;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    margin-bottom: 0;
  }

  input {
    width: 88%;
    border: 1px solid ${props => props.theme.colors.stroke};

    @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 100%;
      background-color: ${props => props.theme.colors.stroke};
    }
  }

  button {
    padding: 10px 50px;
    cursor: pointer;
  }
  > input,
  > button {
    -webkit-transition: ${props => props.theme.transitions.default};
    -moz-transition: ${props => props.theme.transitions.default};
    -o-transition: ${props => props.theme.transitions.default};
    transition: ${props => props.theme.transitions.default};
  }
  &:hover,
  &:focus {
    > input {
      border-color: ${props => props.theme.colors.black};
    }
    > button {
      background-color: ${props => props.theme.colors.black};
      border-color: ${props => props.theme.colors.black};
    }
  }
`;

const SearchInput = styled.input`
  padding: 10px 15px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border: ${props => props.theme.borders.card};
  border-right: none;
  outline: none;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    border-radius: 10px;
  }
`;

const SearchButton = styled.button`
  padding: 10px 15px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  outline: none;
  border: 1px solid ${props => props.theme.colors.blue};
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.blue};

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    display: none;
  }
`;

const Search = () => {
  const [isActive, setIsActive] = useState(false);
  const [keyword, setKeyword] = useState('');

  const handleSubmit = () => {
    navigate(`/search/${keyword ? '?keyword=' + keyword : ''}`);
  };
  return (
    <SearchWrapper onSubmit={ev => ev.preventDefault()}>
      <SearchInput
        placeholder="Search..."
        onFocus={() => setIsActive(true)}
        onBlur={() => setIsActive(false)}
        value={keyword}
        onChange={ev => setKeyword(ev.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSubmit();
          }
        }}
      />
      <SearchButton isActive={isActive} onClick={handleSubmit}>
        Search
      </SearchButton>
    </SearchWrapper>
  );
};

export default Search;
